import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M4 16h4v-7l4 4l4 -4v7h4","key":"svg-1"}]]

const IconCoinMonero = createReactComponent('outline', 'coin-monero', 'CoinMonero', __iconNode);

export default IconCoinMonero;